import { useCallback } from "react";
import usePagedList from "../../../hooks/usePagedList";

/**
 * A paged tab of one client (timeline, sessions, purchases, emails, notes): binds the
 * client id into the crmApi list function so `usePagedList` gets a stable fetcher.
 *
 * @param {string} clientId
 * @param {(id: string, query: object) => Promise<object>} fetcher a crmApi list function
 * @param {object} [params]
 * @param {number} [pageSize]
 */
export default function useClientTab(clientId, fetcher, params = {}, pageSize = 50) {
  const source = useCallback((query) => fetcher(clientId, query), [clientId, fetcher]);
  return usePagedList(source, params, pageSize);
}
